export const ADMIN_EMAIL = "nl@lefevre-ec.fr";

export function isAdmin(user: { email?: string | null } | null): boolean {
  return !!user && user.email === ADMIN_EMAIL;
}
